module.exports = __webpack_public_path__ + "img/booking.aeee2817.svg";